export const REQUIRED_MESSAGE = "Answer is required";
export const PLACEHOLDER_TEXT = "Choose an option";
